module.exports = __webpack_public_path__ + "static/media/mais.0c9498cc.svg";